import React from "react"
import { ListItemText } from '@mui/material'

export const SettingItem = ({ title = "" }) => <ListItemText primary={title} />
